import troopList from '@/components/h-mode-free/data/troopList'

function getFaction (creatureName) {
  const factionData = troopList.find(({ creatures }) => {
    return creatures.find((c) => c.value === creatureName)
  })
  return factionData?.faction || null
}

function formatTroops (troops) {
  return (troops || []).map((troop) => {
    const [name, amount] = Object.entries(troop)[0] || []
    return {
      faction: getFaction(name),
      creatureName: name,
      amount
    }
  })
}

const state = {
  troops: null,
  selectIndex: null,
}

const getters = {}

const actions = {
  selectTroopItem ({ state, commit }, toIndex) {
    const index = state.selectIndex
    // 选中
    if (index === null) {
      if (Object.keys(state.troops[toIndex])?.[0]) {
        commit('setSelectIndex', toIndex)
      }
    }
    // 取消选中
    else if (toIndex === index) {
      commit('setSelectIndex', null)
    }
    // 交换位置
    else if (toIndex !== index) {
      commit('swapTroop', [index, toIndex])
      commit('setSelectIndex', null)
    }
  },
}

const mutations = {
  setTroops (state, payload) {
    state.troops = formatTroops(payload || new Array(7).fill({}))
  },

  updateTroop (state, { index, troop }) {
    const troops = JSON.parse(JSON.stringify(state.troops))
    troops[index] = troop || {}
    state.troops = troops
  },

  overlapToTroop (state, index) {
    const troop = state.troops[index]
    const troops = state.troops.map(() => {
      return { ...troop }
    })

    state.troops = troops
  },
  fillToTroop (state, index) {
    const troop = state.troops[index]
    const troops = state.troops.map((t) => {
      if (!t.creatureName) {
        return { ...troop }
      }

      return { ...t }
    })

    state.troops = troops
  },

  resetTroops (state) {
    state.troops = null
  },

  setSelectIndex (state, payload) {
    state.selectIndex = payload
  },

  swapTroop (state, [i1, i2]) {
    const troops = JSON.parse(JSON.stringify(state.troops))

    const tempI2 = troops[i2]
    troops[i2] = troops[i1]
    troops[i1] = tempI2

    state.troops = troops
  },
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
